import styled from 'styled-components';
import {getSpacing, getToken} from '@tickchak/react-share/app';

export const inlineContentEditable = styled.div<{$isEmpty?: boolean}>`
    outline: none;
    position: relative;
    padding: ${getSpacing('spaceXs')};
    padding-inline-end: ${getSpacing('spaceLg')};
    -webkit-text-size-adjust: 100%;
    
    &[data-is-empty='true'] {
        color: ${getToken('color.state.warning.main')};
        font-weight: bold;
    }
    
    .variable {
        font-weight: var(--font-weight-bold);
        color: var(--primitive-turquoise-700);
    }
`;
